export default "__VITE_ASSET__CLDu0W9$__"